var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _circle, _circle2, _circle3, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _rect4, _path5, _path6, _path7, _path8, _rect5, _circle4, _circle5, _circle6, _rect6, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCosmosLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340.16 226.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dbe7ed;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{stroke-width:0px;}.cls-2{fill:#f8e7c7;}.cls-3{fill:#240d41;}.cls-4{fill:#fff;}.cls-5{fill:#c1d6e0;}.cls-6{fill:#a169ac;}.cls-7{fill:#67b0e1;}.cls-8{fill:#ae7bb6;}.cls-9{fill:#b33658;}.cls-10{fill:#a32b48;}.cls-11{fill:#f2dfaa;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 226.77,
    y: 113.39,
    width: 113.39,
    height: 113.39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m340.16,113.39h-79.37c-14.81,0-27.4,9.47-32.07,22.68-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68h-34.02v45.35h113.39v-68.03h-47.3c1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34h47.3v-22.68Zm-66.09,90.71c-1.25-3.55-1.94-7.36-1.94-11.34s.69-7.79,1.94-11.34h32.07c-6.26,0-11.34,5.08-11.34,11.34s5.08,11.34,11.34,11.34h-32.07Zm-1.94-56.69c0,6.26-5.08,11.34-11.34,11.34s-11.34-5.08-11.34-11.34,5.08-11.34,11.34-11.34h0c6.26,0,11.34,5.08,11.34,11.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m260.79,136.06h79.37v-22.68h-79.37c-14.81,0-27.4,9.47-32.07,22.68-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68h45.35c6.26,0,11.34,5.08,11.34,11.34s-5.08,11.34-11.34,11.34h-79.37v22.68h79.37c14.81,0,27.4-9.47,32.07-22.68,1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34c-4.67-13.21-17.26-22.68-32.07-22.68h-45.35c-6.26,0-11.34-5.08-11.34-11.34s5.08-11.34,11.34-11.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m249.45,147.4c0-6.26,5.08-11.34,11.34-11.34,0,0,0,0,0,0,0,0,0,0,0,0h32.07c-4.67-13.21-17.26-22.68-32.07-22.68s-27.4,9.47-32.07,22.68c-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68,5.24,0,10.21-1.19,14.65-3.31,3.35-7.02,9.04-12.7,16.06-16.06.51-1.07.97-2.18,1.37-3.31h-32.07c-6.26,0-11.34-5.08-11.34-11.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m338.21,181.42c-4.67-13.21-17.26-22.68-32.07-22.68-5.24,0-10.21,1.19-14.65,3.31-3.35,7.02-9.04,12.7-16.06,16.06-.51,1.07-.97,2.18-1.37,3.31h32.07c6.26,0,11.34,5.08,11.34,11.34s-5.08,11.34-11.34,11.34h-32.07c4.67,13.21,17.26,22.68,32.07,22.68s27.4-9.47,32.07-22.68c1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.39,
    y: 113.39,
    width: 113.39,
    height: 113.39
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 170.08,
    cy: 170.08,
    r: 56.69
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 170.08,
    cy: 170.08,
    r: 34.02
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 170.08,
    cy: 170.08,
    r: 14.17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 113.39,
    width: 113.39,
    height: 113.39
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.2 113.39 56.69 138.9 56.69 170.08 56.69 170.08 56.69 205.51 56.69 205.51 77.95 226.77 92.13 226.77 113.39 226.77 113.39 226.77 113.39 113.39 82.2 113.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "31.18 113.39 56.69 138.9 56.69 170.08 56.69 170.08 56.69 205.51 56.69 205.51 35.43 226.77 21.26 226.77 0 226.77 0 226.77 0 113.39 31.18 113.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "56.69 170.08 56.69 170.08 56.69 205.51 74.41 187.8 92.13 170.08 92.13 205.51 92.13 205.51 92.13 226.77 113.39 226.77 113.39 226.77 113.39 113.39 56.69 170.08"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0 113.39 0 226.77 21.26 226.77 21.26 205.51 21.26 170.08 38.98 187.8 38.98 187.8 56.69 205.51 56.69 205.51 56.69 170.08 0 113.39"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 226.77,
    y: 0,
    width: 113.39,
    height: 113.39
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m340.16,0h-79.37C245.98,0,233.39,9.47,228.71,22.68c-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68h-34.02v45.35h113.39V45.35h-47.3c1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34h47.3V0Zm-66.09,90.71c-1.25-3.55-1.94-7.36-1.94-11.34s.69-7.79,1.94-11.34h32.07c-6.26,0-11.34,5.08-11.34,11.34s5.08,11.34,11.34,11.34h-32.07Zm-1.94-56.69c0,6.26-5.08,11.34-11.34,11.34s-11.34-5.08-11.34-11.34,5.08-11.34,11.34-11.34h0c6.26,0,11.34,5.08,11.34,11.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m260.79,22.68h79.37V0h-79.37C245.98,0,233.39,9.47,228.71,22.68c-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68h45.35c6.26,0,11.34,5.08,11.34,11.34s-5.08,11.34-11.34,11.34h-79.37v22.68h79.37c14.81,0,27.4-9.47,32.07-22.68,1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34c-4.67-13.21-17.26-22.68-32.07-22.68h-45.35c-6.26,0-11.34-5.08-11.34-11.34s5.08-11.34,11.34-11.34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m249.45,34.02c0-6.26,5.08-11.34,11.34-11.34,0,0,0,0,0,0,0,0,0,0,0,0h32.07C288.19,9.47,275.6,0,260.79,0s-27.4,9.47-32.07,22.68c-1.25,3.55-1.94,7.36-1.94,11.34s.69,7.79,1.94,11.34c4.67,13.21,17.26,22.68,32.07,22.68,5.24,0,10.21-1.19,14.65-3.31,3.35-7.02,9.04-12.7,16.06-16.06.51-1.07.97-2.18,1.37-3.31h-32.07c-6.26,0-11.34-5.08-11.34-11.34Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m338.21,68.03c-4.67-13.21-17.26-22.68-32.07-22.68-5.24,0-10.21,1.19-14.65,3.31-3.35,7.02-9.04,12.7-16.06,16.06-.51,1.07-.97,2.18-1.37,3.31h32.07c6.26,0,11.34,5.08,11.34,11.34s-5.08,11.34-11.34,11.34h-32.07c4.67,13.21,17.26,22.68,32.07,22.68s27.4-9.47,32.07-22.68c1.25-3.55,1.94-7.36,1.94-11.34s-.69-7.79-1.94-11.34Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 113.39,
    width: 113.39,
    height: 113.39
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.08,
    cy: 56.69,
    r: 56.69
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.08,
    cy: 56.69,
    r: 34.02
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 170.08,
    cy: 56.69,
    r: 14.17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 113.39,
    height: 113.39
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m96.78,96.78c10.26-10.26,16.6-24.43,16.6-40.09v56.69l-16.6-16.6ZM0,0v56.69C0,41.04,6.35,26.86,16.61,16.6,26.86,6.35,41.04,0,56.69,0H0Zm16.6,96.78C6.35,86.52,0,72.35,0,56.69v56.69h56.69c-15.66,0-29.83-6.35-40.09-16.6ZM96.78,16.6c10.26,10.26,16.6,24.43,16.6,40.09V0l-16.6,16.6Zm-16.04,16.04l-24.05,24.05,24.05,24.05c6.16-6.16,9.96-14.66,9.96-24.05s-3.81-17.9-9.96-24.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m56.69,90.71c-9.39,0-17.9-3.81-24.05-9.96-6.16-6.16-9.96-14.66-9.96-24.05s3.81-17.9,9.96-24.05c6.16-6.16,14.66-9.96,24.05-9.96s17.9,3.81,24.05,9.96l16.04-16.04C86.52,6.35,72.35,0,56.69,0S26.86,6.35,16.61,16.6C6.35,26.86,0,41.04,0,56.69s6.35,29.83,16.6,40.09c10.26,10.26,24.43,16.6,40.09,16.6s29.83-6.35,40.09-16.6l-16.04-16.04c-6.16,6.16-14.66,9.96-24.05,9.96Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmosLogo);
export default __webpack_public_path__ + "static/media/cosmos_logo.d8fa7edb6f16826495c611f7bfe21a87.svg";
export { ForwardRef as ReactComponent };